import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
// Selectors
import { selectFilter } from 'src/store/selectors/filters'
// Components
import { FormField, Text } from 'src/Components'
// Constants
import { MIN_SQFT, MAX_SQFT, SQFT_SUFFIX } from 'src/constants/listings'
// Styles
import styles from './BuildingSize.module.scss'
import filterStyles from '../Filters.module.scss'

const BuildingSize = () => {
  const filters = useSelector(selectFilter)

  return (
    <>
      <Text
        align='left'
        element='h2'
        weight='bold'
        variant='neutralCool'
        variantCount='900'
        className={filterStyles.sectionTitle}
      >
        <FormattedMessage
          id='HomeSearch.listings.filters.buildingSize.heading'
          defaultMessage='Building size'
        />
      </Text>
      <div className={styles.rangeFields}>
        <FormField.SqFt
          allowNegative={false}
          className={styles.rangeField}
          defaultValue={filters[MIN_SQFT]}
          name={MIN_SQFT}
          suffix={SQFT_SUFFIX}
        >
          <FormattedMessage
            id='HomeSearch.listings.filters.sqFt.minimum'
            defaultMessage='Minimum'
          />
        </FormField.SqFt>
        <div className={styles.dashMark}>—</div>
        <FormField.SqFt
          allowNegative={false}
          className={styles.rangeField}
          defaultValue={filters[MAX_SQFT]}
          name={MAX_SQFT}
          suffix={SQFT_SUFFIX}
        >
          <FormattedMessage
            id='HomeSearch.listings.filters.sqFt.maximum'
            defaultMessage='Maximum'
          />
        </FormField.SqFt>
      </div>
    </>
  )
}

BuildingSize.parseValue = unsafeValue => {
  const unparsedValue = unsafeValue.replace(/[ft²,\s]/g, '')
  const value = parseFloat(unparsedValue, 10)
  return value
}

export default BuildingSize
